export const tenantAdminRoutes = [
  {
    path: '/s/:structureIndex',
    component: () => import('src/modules/core/layout/LayoutAdmin.vue'),
    children: [
      // Accueil
      {
        path: '',
        name: 'back-office-homepage',
        meta: {
          title: 'Accueil'
        },
        component: () => import('src/modules/back-office/views/DashboardPage.vue')
      },
      {
        path: '',
        name: 'admin-homepage',
        meta: {
          title: 'Mon établissement'
        },
        component: () => import('src/modules/structures/views/AdminEstablishment.vue')
      },
      // List patients
      {
        path: 'patients-list',
        name: 'patients-list',
        meta: {
          title: 'Liste des patients'
        },
        component: () => import('src/modules/back-office/views/PatientsPage.vue')
      },
      {
        path: 'patients-observance',
        name: 'patients-observance',
        meta: {
          title: 'Observance patients'
        },
        component: () => import('src/modules/back-office/views/PatientsObservancePage.vue')
      },
      // Status d'alertes
      {
        path: 'alert-statuses',
        name: 'alert-statuses-list',
        meta: {
          title: 'Statut d\'alerte'
        },
        component: () => import('src/modules/alert-status-intervention-level/views/AlertStatusPage.vue')
      },
      // Indicateurs
      {
        path: 'indicators',
        name: 'indicators-list',
        meta: {
          title: 'Indicateurs'
        },
        component: () => import('src/modules/indicators/views/GlobalIndicators.vue')
      },
      {
        path: 'indicators-visibility',
        name: 'indicators-visibility-list',
        meta: {
          title: 'Indicateurs'
        },
        component: () => import('src/modules/indicators/views/Indicators.vue')
      },
      // Données calculées
      {
        path: 'calculated-data',
        name: 'calculated-data-list',
        meta: {
          title: 'Données calculées'
        },
        component: () => import('src/modules/calculated-data/views/CalculatedData.vue')
      },
      {
        path: 'calculated-data/:id/editor',
        name: 'calculated-data-edit',
        meta: {
          title: 'Données calculées'
        },
        props: true,
        component: () => import('src/modules/calculated-data/views/CalculatedDataView.vue')
      },
      // Données externes
      {
        path: 'external-data',
        name: 'external-data-list',
        meta: {
          title: 'Données externes'
        },
        component: () => import('src/modules/external-data/views/ExternalData.vue')
      },
      // Questionnaires
      {
        path: 'surveys',
        name: 'surveys-list',
        meta: {
          title: 'Questionnaires'
        },
        component: () => import('src/modules/surveys/views/Surveys.vue')
      },
      {
        path: 'surveys/:id/editor',
        name: 'survey-edit',
        meta: {
          title: 'Questionnaires'
        },
        component: () => import('src/modules/surveys/views/SurveyEditor.vue'),
        props: true
      },
      // Paramètres supplémentaires
      {
        path: 'properties',
        name: 'properties-list',
        meta: {
          title: 'Paramètres supplémentaires'
        },
        component: () => import('src/modules/properties/views/Properties.vue')
      },
      // Objets connectés
      {
        path: 'iot-devices',
        name: 'iot-devices-list',
        meta: {
          title: 'Objets connectés'
        },
        component: () => import('src/modules/iot/views/Devices.vue')
      },
      // Notes de mise à jour
      {
        path: 'changelogs',
        name: 'changelogs-list',
        meta: {
          title: 'Notes de mise à jour'
        },
        component: () => import('src/modules/changelogs/views/ManageChangelogs.vue')
      },
      {
        path: 'changelogs/:id',
        name: 'changelog-edit',
        meta: {
          title: 'Note de mise à jour'
        },
        component: () => import('src/modules/changelogs/views/ManageChangelogItem.vue'),
        props: true
      }
    ]
  },
  {
    path: '/structure-create',
    name: 'create-structure',
    meta: {
      title: 'Mon établissement'
    },
    component: () => import('src/modules/structures/components/StructureStart.vue')
  }
]
